import { useMessage } from "../../../../../../Utils/useMessage";
import classNames from "classnames";
import styles from "./index.module.scss";

import React, { useRef } from "react";
import { MsgType } from "../../../../../../types";
import FileMessage from "../FileMessage";
import { useDeviceType } from "../../../../../../polyfills";
import { useLongPress } from "react-use";
import MessageAccused from "../MessageAccused";

export interface ContextEvent {
    clientX: number;
    clientY: number;
    preventDefault?(): void;
}

interface MessageContentProps {
    sessionId: string;
    messageId: string;
    onContextMenu(e: ContextEvent): void;
}

export default function MessageContent({
    sessionId,
    messageId,
    onContextMenu
}: MessageContentProps) {
    const ref = useRef<HTMLDivElement>(null);
    const { isPC } = useDeviceType();
    const { message } = useMessage(sessionId, messageId);

    const pressEvent = useLongPress(evt => {
        if (isPC) return;

        const { x = 0, y = 0 } = ref.current?.getBoundingClientRect() || {};
        onContextMenu({ clientX: x, clientY: y });
    });

    if (!message) return null;

    if (message.isAccused) {
        return (
            <MessageAccused
                className={classNames(styles.root, styles.accused)}
            />
        );
    }

    return (
        <div
            className={styles.root}
            onContextMenu={isPC ? onContextMenu : undefined}>
            <div ref={ref} className={styles.wrapper} {...pressEvent}>
                {message.type === MsgType.TEXT && (
                    <div className={styles.textMsg}>{message.content}</div>
                )}

                {message.type === MsgType.FILE && (
                    <FileMessage sessionId={sessionId} messageId={messageId} />
                )}
            </div>
        </div>
    );
}
